/*
*  Utilities used to make API calls
*/

//Turns an error response from the server into a message that can be shown to the visitor
const getErrorText = (errorResponse) => {
  if (errorResponse && errorResponse.errors) {
    //Model validation error - show the first message
    const firstKey = Object.keys(errorResponse.errors)[0];
    return errorResponse.errors[firstKey][0];
  }
  if (errorResponse && errorResponse.errorText) {
    return errorResponse.errorText;
  }
  return "Your message could not be sent. Please try again.";
};

//Does a post request (without an auth token). Resolves on success, rejects with a user friendly message on failure
export const postRequest = async (url, data) => {
  //Set abort timeout
  const controller = new AbortController();
  const timeout = setTimeout(() => {
    controller.abort();
  }, 15000);

  let response;
  try {
    response = await fetch(`/api${url}`, {
      method: "POST",
      body: JSON.stringify(data),
      headers: {
        "Content-Type": "application/json",
      },
      signal: controller.signal,
    });
  }
  catch (e) {
    throw new Error(controller.signal.aborted ?
      "The request timed out. Please check your connection and try again." :
      "Your message could not be sent. Please check your connection and try again.");
  }
  finally {
    clearTimeout(timeout);
  }

  if (response.ok) {
    return;
  }

  let errorResponse = null;
  try {
    errorResponse = await response.json();
  }
  catch (e) {
    //Not JSON - use the generic message
  }
  throw new Error(getErrorText(errorResponse));
};
